module.exports = __webpack_public_path__ + "static/media/Mt_Mitchell_State_Park_Museum_diorama_installed_2016.8d9f2c62.webp";